import { default as account1snPdB0rXmMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/account.vue?macro=true";
import { default as cartaCp88nqICrMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/cart.vue?macro=true";
import { default as christmas_452024SIY11lkemUMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/contests/christmas-2024.vue?macro=true";
import { default as couponlP3dvwbxrgMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/coupon.vue?macro=true";
import { default as downloadsSy16Ig4hOrMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/downloads.vue?macro=true";
import { default as imprintyYoWmMtMgPMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/imprint.vue?macro=true";
import { default as indexMIubGbWaEBMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/index.vue?macro=true";
import { default as privacypolicy8mY1SdqmkgMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/privacypolicy.vue?macro=true";
import { default as index1fHX5aBlzYMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/products/bundles/index.vue?macro=true";
import { default as _91slug_93K9y03n916QMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/products/guitar-cabinet-impulse-responses/[slug].vue?macro=true";
import { default as indexUM5o1bS3JwMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/products/guitar-cabinet-impulse-responses/index.vue?macro=true";
import { default as indexoMsK6i2BjfMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/products/index.vue?macro=true";
import { default as _91slug_93G4GAu3vW0CMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/products/plugins/[slug].vue?macro=true";
import { default as indexqXzNmcIw5LMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/products/plugins/index.vue?macro=true";
import { default as rate_45productF3Bc8A1xLoMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/rate-product.vue?macro=true";
import { default as black_45friday_45sale5fQPJguJTrMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/sales/black-friday-sale.vue?macro=true";
import { default as cyber_45monday_45sale4CrkIo4mpYMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/sales/cyber-monday-sale.vue?macro=true";
import { default as index86NwOJ6Bk3Meta } from "/home/adf/Code/fanuxtest/faNuxt/pages/sales/index.vue?macro=true";
import { default as shoplnhZj71SI2Meta } from "/home/adf/Code/fanuxtest/faNuxt/pages/shop.vue?macro=true";
import { default as supportWx3IDsDHDDMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/support.vue?macro=true";
import { default as terms_45conditionsNm3LFVetMsMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/terms-conditions.vue?macro=true";
import { default as _91slug_93sTjugggQooMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/tutorials/[category]/[slug].vue?macro=true";
import { default as indexSknIasgqFjMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/tutorials/[category]/index.vue?macro=true";
import { default as indexS1i5afGeeqMeta } from "/home/adf/Code/fanuxtest/faNuxt/pages/tutorials/index.vue?macro=true";
export default [
  {
    name: account1snPdB0rXmMeta?.name ?? "account",
    path: account1snPdB0rXmMeta?.path ?? "/account",
    meta: account1snPdB0rXmMeta || {},
    alias: account1snPdB0rXmMeta?.alias || [],
    redirect: account1snPdB0rXmMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/account.vue").then(m => m.default || m)
  },
  {
    name: cartaCp88nqICrMeta?.name ?? "cart",
    path: cartaCp88nqICrMeta?.path ?? "/cart",
    meta: cartaCp88nqICrMeta || {},
    alias: cartaCp88nqICrMeta?.alias || [],
    redirect: cartaCp88nqICrMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/cart.vue").then(m => m.default || m)
  },
  {
    name: christmas_452024SIY11lkemUMeta?.name ?? "contests-christmas-2024",
    path: christmas_452024SIY11lkemUMeta?.path ?? "/contests/christmas-2024",
    meta: christmas_452024SIY11lkemUMeta || {},
    alias: christmas_452024SIY11lkemUMeta?.alias || [],
    redirect: christmas_452024SIY11lkemUMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/contests/christmas-2024.vue").then(m => m.default || m)
  },
  {
    name: couponlP3dvwbxrgMeta?.name ?? "coupon",
    path: couponlP3dvwbxrgMeta?.path ?? "/coupon",
    meta: couponlP3dvwbxrgMeta || {},
    alias: couponlP3dvwbxrgMeta?.alias || [],
    redirect: couponlP3dvwbxrgMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/coupon.vue").then(m => m.default || m)
  },
  {
    name: downloadsSy16Ig4hOrMeta?.name ?? "downloads",
    path: downloadsSy16Ig4hOrMeta?.path ?? "/downloads",
    meta: downloadsSy16Ig4hOrMeta || {},
    alias: downloadsSy16Ig4hOrMeta?.alias || [],
    redirect: downloadsSy16Ig4hOrMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/downloads.vue").then(m => m.default || m)
  },
  {
    name: imprintyYoWmMtMgPMeta?.name ?? "imprint",
    path: imprintyYoWmMtMgPMeta?.path ?? "/imprint",
    meta: imprintyYoWmMtMgPMeta || {},
    alias: imprintyYoWmMtMgPMeta?.alias || [],
    redirect: imprintyYoWmMtMgPMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/imprint.vue").then(m => m.default || m)
  },
  {
    name: indexMIubGbWaEBMeta?.name ?? "index",
    path: indexMIubGbWaEBMeta?.path ?? "/",
    meta: indexMIubGbWaEBMeta || {},
    alias: indexMIubGbWaEBMeta?.alias || [],
    redirect: indexMIubGbWaEBMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: privacypolicy8mY1SdqmkgMeta?.name ?? "privacypolicy",
    path: privacypolicy8mY1SdqmkgMeta?.path ?? "/privacypolicy",
    meta: privacypolicy8mY1SdqmkgMeta || {},
    alias: privacypolicy8mY1SdqmkgMeta?.alias || [],
    redirect: privacypolicy8mY1SdqmkgMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: index1fHX5aBlzYMeta?.name ?? "products-bundles",
    path: index1fHX5aBlzYMeta?.path ?? "/products/bundles",
    meta: index1fHX5aBlzYMeta || {},
    alias: index1fHX5aBlzYMeta?.alias || [],
    redirect: index1fHX5aBlzYMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/products/bundles/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93K9y03n916QMeta?.name ?? "products-guitar-cabinet-impulse-responses-slug",
    path: _91slug_93K9y03n916QMeta?.path ?? "/products/guitar-cabinet-impulse-responses/:slug()",
    meta: _91slug_93K9y03n916QMeta || {},
    alias: _91slug_93K9y03n916QMeta?.alias || [],
    redirect: _91slug_93K9y03n916QMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/products/guitar-cabinet-impulse-responses/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexUM5o1bS3JwMeta?.name ?? "products-guitar-cabinet-impulse-responses",
    path: indexUM5o1bS3JwMeta?.path ?? "/products/guitar-cabinet-impulse-responses",
    meta: indexUM5o1bS3JwMeta || {},
    alias: indexUM5o1bS3JwMeta?.alias || [],
    redirect: indexUM5o1bS3JwMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/products/guitar-cabinet-impulse-responses/index.vue").then(m => m.default || m)
  },
  {
    name: indexoMsK6i2BjfMeta?.name ?? "products",
    path: indexoMsK6i2BjfMeta?.path ?? "/products",
    meta: indexoMsK6i2BjfMeta || {},
    alias: indexoMsK6i2BjfMeta?.alias || [],
    redirect: indexoMsK6i2BjfMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93G4GAu3vW0CMeta?.name ?? "products-plugins-slug",
    path: _91slug_93G4GAu3vW0CMeta?.path ?? "/products/plugins/:slug()",
    meta: _91slug_93G4GAu3vW0CMeta || {},
    alias: _91slug_93G4GAu3vW0CMeta?.alias || [],
    redirect: _91slug_93G4GAu3vW0CMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/products/plugins/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexqXzNmcIw5LMeta?.name ?? "products-plugins",
    path: indexqXzNmcIw5LMeta?.path ?? "/products/plugins",
    meta: indexqXzNmcIw5LMeta || {},
    alias: indexqXzNmcIw5LMeta?.alias || [],
    redirect: indexqXzNmcIw5LMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/products/plugins/index.vue").then(m => m.default || m)
  },
  {
    name: rate_45productF3Bc8A1xLoMeta?.name ?? "rate-product",
    path: rate_45productF3Bc8A1xLoMeta?.path ?? "/rate-product",
    meta: rate_45productF3Bc8A1xLoMeta || {},
    alias: rate_45productF3Bc8A1xLoMeta?.alias || [],
    redirect: rate_45productF3Bc8A1xLoMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/rate-product.vue").then(m => m.default || m)
  },
  {
    name: black_45friday_45sale5fQPJguJTrMeta?.name ?? "sales-black-friday-sale",
    path: black_45friday_45sale5fQPJguJTrMeta?.path ?? "/sales/black-friday-sale",
    meta: black_45friday_45sale5fQPJguJTrMeta || {},
    alias: black_45friday_45sale5fQPJguJTrMeta?.alias || [],
    redirect: black_45friday_45sale5fQPJguJTrMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/sales/black-friday-sale.vue").then(m => m.default || m)
  },
  {
    name: cyber_45monday_45sale4CrkIo4mpYMeta?.name ?? "sales-cyber-monday-sale",
    path: cyber_45monday_45sale4CrkIo4mpYMeta?.path ?? "/sales/cyber-monday-sale",
    meta: cyber_45monday_45sale4CrkIo4mpYMeta || {},
    alias: cyber_45monday_45sale4CrkIo4mpYMeta?.alias || [],
    redirect: cyber_45monday_45sale4CrkIo4mpYMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/sales/cyber-monday-sale.vue").then(m => m.default || m)
  },
  {
    name: index86NwOJ6Bk3Meta?.name ?? "sales",
    path: index86NwOJ6Bk3Meta?.path ?? "/sales",
    meta: index86NwOJ6Bk3Meta || {},
    alias: index86NwOJ6Bk3Meta?.alias || [],
    redirect: index86NwOJ6Bk3Meta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/sales/index.vue").then(m => m.default || m)
  },
  {
    name: shoplnhZj71SI2Meta?.name ?? "shop",
    path: shoplnhZj71SI2Meta?.path ?? "/shop",
    meta: shoplnhZj71SI2Meta || {},
    alias: shoplnhZj71SI2Meta?.alias || [],
    redirect: shoplnhZj71SI2Meta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/shop.vue").then(m => m.default || m)
  },
  {
    name: supportWx3IDsDHDDMeta?.name ?? "support",
    path: supportWx3IDsDHDDMeta?.path ?? "/support",
    meta: supportWx3IDsDHDDMeta || {},
    alias: supportWx3IDsDHDDMeta?.alias || [],
    redirect: supportWx3IDsDHDDMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/support.vue").then(m => m.default || m)
  },
  {
    name: terms_45conditionsNm3LFVetMsMeta?.name ?? "terms-conditions",
    path: terms_45conditionsNm3LFVetMsMeta?.path ?? "/terms-conditions",
    meta: terms_45conditionsNm3LFVetMsMeta || {},
    alias: terms_45conditionsNm3LFVetMsMeta?.alias || [],
    redirect: terms_45conditionsNm3LFVetMsMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/terms-conditions.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93sTjugggQooMeta?.name ?? "tutorials-category-slug",
    path: _91slug_93sTjugggQooMeta?.path ?? "/tutorials/:category()/:slug()",
    meta: _91slug_93sTjugggQooMeta || {},
    alias: _91slug_93sTjugggQooMeta?.alias || [],
    redirect: _91slug_93sTjugggQooMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/tutorials/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexSknIasgqFjMeta?.name ?? "tutorials-category",
    path: indexSknIasgqFjMeta?.path ?? "/tutorials/:category()",
    meta: indexSknIasgqFjMeta || {},
    alias: indexSknIasgqFjMeta?.alias || [],
    redirect: indexSknIasgqFjMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/tutorials/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexS1i5afGeeqMeta?.name ?? "tutorials",
    path: indexS1i5afGeeqMeta?.path ?? "/tutorials",
    meta: indexS1i5afGeeqMeta || {},
    alias: indexS1i5afGeeqMeta?.alias || [],
    redirect: indexS1i5afGeeqMeta?.redirect || undefined,
    component: () => import("/home/adf/Code/fanuxtest/faNuxt/pages/tutorials/index.vue").then(m => m.default || m)
  }
]